import { forwardRef, HTMLProps } from 'react';
import clsx from 'clsx';

const Input = forwardRef<HTMLInputElement, HTMLProps<HTMLInputElement>>(({ children, className, ...props }, ref) => {
  return (
    <input
      {...props}
      ref={ref}
      className={clsx('py-2 px-4 rounded border border-brand-purple-border text-sm font-semibold', className)}
    >
      {children}
    </input>
  );
});

Input.displayName = 'Input';

export default Input;
